import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { LocationState } from '@core/locations/models/location-state.interface';

@Injectable({
  providedIn: 'root',
})
export class StatesService {
  private readonly httpClient = inject(HttpClient);

  getStates(countryId: number): Observable<LocationState[]> {
    const url = `api/v1/lookups/countries/${countryId}/states`;

    return this.httpClient.get<LocationState[]>(environment.portalApiUrl + url);
  }
}
